<script setup lang="ts">
import {
  defineProps, onMounted, ref, watch,
} from 'vue';

import { Form } from '~/schemas/invoiceDataForm.schema';

const { form } = defineProps<{
  form: Form
}>();

const emails = ref<string[]>([]);

const [suplierModel, suplierProps] = form.defineField('suplier');

function getEmails(): Promise<string> {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve('eduardo@mail.com,hugo@mail.com');
    }, 1000);
  });
}

onMounted(async () => {
  await getEmails().then((res) => {
    const d = res.split(',');
    emails.value = d;
  });
});

watch(emails, (value) => {
  value.forEach((email, i) => {
    form.setFieldValue(`emails.${i}`, email);
  });
});

function addEmailField() {
  const lastIndex = (form.values.emails || []).length - 1;
  const lastItem = form.values.emails?.[lastIndex];
  if (lastItem === '' || lastItem === undefined || lastItem === '') {
    return;
  }

  form.setFieldValue('emails', [...(form.values.emails || ['']), ''] as [string, ...string[]]);
}

function removeEmailField(index: number) {
  const updatedEmails = form.values.emails?.filter((_, i) => (i !== index)) || [];
  // Ensure we have at least one empty string to satisfy the nonempty array requirement
  if (updatedEmails.length === 0) {
    updatedEmails.push('');
  }
  form.setFieldValue('emails', updatedEmails as [string, ...string[]]);
}

</script>

<template>
  <form class="columns is-multiline">
    <!--  -->
    <div class="column is-3">
      <div class="field">
        <label class="label" for="suplier">Suplier</label>
        <input v-bind="suplierProps" class="input" id="suplier" type="text" v-model="suplierModel" />
        <small class="help is-danger">{{ form.errors.value.suplier }}</small>
      </div>
    </div>
    <!--  -->

    <div class="column is-3">
      <div class="field">
        <label class="label" for="emails">Emails</label>
        <div :key="i" v-for="i in form.values.emails?.length || 1">
          {{ i - 1 }}
          <input
            :value="form.values.emails?.[i - 1]"
            @blur="form.setFieldTouched(`emails.${i - 1}`, true)"
            @input="(e) => form.setFieldValue(`emails.${i - 1}`, (e.target as HTMLInputElement).value)"
            class="input"
            id="emails"
            type="text" />
          <button @click="removeEmailField(i - 1)" type="button">Remove</button>
          <small class="help is-danger">{{ form.errors.value[`emails.${i - 1}`] }}</small>
        </div>
        <button @click="addEmailField" type="button">Add Email</button>
      </div>
    </div>
  </form>
</template>
